import { merge } from 'ramda';
import { TActions } from '../../types';
import { CHANGE_SAVED_OFFER } from './actions';
import { ISavedOfferState } from './types';

export function savedOffer(state: ISavedOfferState | null, action: TActions): ISavedOfferState | null {
  switch (action.type) {
    case CHANGE_SAVED_OFFER:
      if (action.payload === null) {
        return action.payload;
      }

      return merge(state || {}, action.payload);

    default:
      return state || null;
  }
}
